const PhoneCallIcon = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.4342 10.3887C11.6015 10.3887 10.7858 10.2587 10.0127 10.0036C9.63544 9.87355 9.207 9.97373 8.95903 10.2267L7.42643 11.3841C5.66787 10.4455 4.5424 9.32077 3.61659 7.575L4.74277 6.07864C5.02627 5.79514 5.12788 5.38018 5.00638 4.99153C4.74916 4.2135 4.61844 3.39711 4.61844 2.56579C4.61844 1.97817 4.14026 1.5 3.55265 1.5H1.06579C0.478173 1.5 0 1.97817 0 2.56579C0 9.42165 5.57835 15 12.4342 15C13.0218 15 13.5 14.5218 13.5 13.9342V11.4545C13.5 10.8669 13.0218 10.3887 12.4342 10.3887Z"
      fill="#2C2543"
    />
    <g clipPath="url(#clip0_5863_59105)">
      <path
        d="M13.906 1.11522C13.1781 0.378465 12.1782 -0.0249948 11.1432 0.00131782C9.08207 0.0627139 7.46823 1.77303 7.52962 3.83419C7.53839 4.26396 7.6261 4.68496 7.78398 5.07965C7.91554 5.41294 8.09096 5.71992 8.31023 6.00059L8.00325 6.72857C7.88046 7.00924 8.01202 7.33376 8.29269 7.45655C8.38917 7.50041 8.50319 7.50918 8.60844 7.49164L10.0293 7.24605C10.538 7.42147 11.0731 7.48286 11.6081 7.43024C13.4412 7.24605 14.8708 5.74623 14.9673 3.90435C15.0199 2.86062 14.634 1.85197 13.906 1.11522ZM10.9766 5.21121H10.003C9.8539 5.21121 9.72234 5.08842 9.72234 4.93054C9.72234 4.78144 9.84513 4.64988 10.003 4.64988H10.9766C11.1257 4.64988 11.2572 4.77267 11.2572 4.93054C11.2572 5.08842 11.1344 5.21121 10.9766 5.21121ZM12.4939 4.071H10.003C9.8539 4.071 9.72234 3.94821 9.72234 3.79033C9.72234 3.63246 9.84513 3.50966 10.003 3.50966H12.4939C12.643 3.50966 12.7746 3.63246 12.7746 3.79033C12.7746 3.94821 12.643 4.071 12.4939 4.071ZM12.4939 2.92202H10.003C9.8539 2.92202 9.72234 2.79922 9.72234 2.64135C9.72234 2.49224 9.84513 2.36068 10.003 2.36068H12.4939C12.643 2.36068 12.7746 2.48347 12.7746 2.64135C12.7746 2.79045 12.643 2.92202 12.4939 2.92202Z"
        fill="#2C2543"
      />
    </g>
    <defs>
      <clipPath id="clip0_5863_59105">
        <rect
          width="7.5"
          height="7.5"
          fill="white"
          transform="translate(7.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PhoneCallIcon;
